
import { defineComponent, onMounted, ref } from "vue";

import BirthdayCake from "@/components/BirthdayCake.vue";
import BestWish from "@/components/BestWish.vue";
import bubble from "@/assets/utils/bubble";

import { useRoute } from "vue-router";

export default defineComponent({
  name: "card",
  components: {
    BirthdayCake,
    BestWish,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  setup() {
    const route = useRoute();
    const name = route.query.name as string;
    const msg = route.query.msg as string;

    const music = ref<HTMLAudioElement | null>(null);

    function playMusic() {
      music.value?.play();
    }

    onMounted(() => {
      bubble();
    });

    return {
      name,
      msg,

      music,

      playMusic,
    };
  },
});
